// extracted by mini-css-extract-plugin
export default {"button":"_a0e94e90"};